import { useTranslation } from "react-i18next"
import { ComboEntity } from "../../Objects/Combo/ComboEntity"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { DeleteRequest } from "../../services/ApiClientService"

export const useRemoveCombo = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const handleRemoveCombo = async (combo: ComboEntity, onSuccess: any) => {
    enableLoad()
    
    try {
      const response = await DeleteRequest(`${API_ROUTES.COMBO.DELETE}/${combo.id}`)
      
      if (response.success) {

        onSuccess()

        return
      }
      throw new Error(response.message)

    } catch (e) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")

      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return { handleRemoveCombo }
}
